module.exports = __webpack_public_path__ + "h5/img/logo.8a8358dd.jpg";